export var global = { a: '' }


// WEBPACK FOOTER //
// ./src/api/global.js